// src/features/carousel/services/carouselApi.js
import { apiSlice } from '../../../app/api/apiSlice';
// @ts-ignore
import { CarouselItem, CreateCarouselItemPayload, UpdateCarouselItemPayload, ApiResponse } from './carouselTypes';

export const carouselApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // सभी कैरोसेल आइटम्स प्राप्त करें (एडमिन के लिए)
    getAllCarouselItems: builder.query({
      query: () => '/api/v1/admin/carousel', // <--- URL अपडेटेड
      providesTags: (result) => {
        return result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({ type: 'CarouselItem', id: _id })),
              { type: 'CarouselItem', id: 'LIST' }
            ]
          : [{ type: 'CarouselItem', id: 'LIST' }];
      },
    }),

    // एक विशिष्ट कैरोसेल आइटम को ID द्वारा प्राप्त करें
    getCarouselItemById: builder.query({
      query: (id) => `/api/v1/admin/carousel/${id}`, // <--- URL अपडेटेड
      providesTags: (result, error, id) => [{ type: 'CarouselItem', id }],
    }),

    // नया कैरोसेल आइटम बनाएँ
    createCarouselItem: builder.mutation({
      query: (formData) => ({
        url: '/api/v1/admin/carousel', // <--- URL अपडेटेड
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: [{ type: 'CarouselItem', id: 'LIST' }],
    }),

    // कैरोसेल आइटम अपडेट करें
    updateCarouselItem: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/api/v1/admin/carousel/${id}`, // <--- URL अपडेटेड
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'CarouselItem', id },
        { type: 'CarouselItem', id: 'LIST' }
      ],
    }),

    // कैरोसेल आइटम डिलीट करें
    deleteCarouselItem: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/carousel/${id}`, // <--- URL अपडेटेड
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'CarouselItem', id },
        { type: 'CarouselItem', id: 'LIST' }
      ],
    }),
  }),
});

export const {
  useGetAllCarouselItemsQuery,
  useGetCarouselItemByIdQuery,
  useCreateCarouselItemMutation,
  useUpdateCarouselItemMutation,
  useDeleteCarouselItemMutation,
} = carouselApi;